let getColorByStatusUnits = (status: any = "", type: any = "") => {
  let color: string;
  switch (status) {
    case "Work":
      color = "99EBAD"
      break
    case "Moving":
      color = "9CFA5A"
      break
    case "Free":
      color = "B3B6B7"
      break
    case "Unauthorized":
      color = "F8B65B"
      break
    case "Stop":
      color = "DA1D1F"
      break
    case "ConnectionLoss":
      color = "DA1D1F"
      break
    default:
      color = "DA1D1F"
  }
  
  return (type === "DEC" ? `0x` : `#`) + color
}

let hex2number = (value: any, type: "HEX" | "DEC" = "DEC") : number =>{
  
  let copyValue: any = `${value}`
  let listSymbolsToRemove = ["0x", "#"]
  listSymbolsToRemove.forEach((separator: string)=>{
    copyValue = copyValue.split(separator).filter((i: any)=>i).join()
  })
  
  // switch (type) {
  //   case "HEX": return `#${copyValue}`
  //   case "DEC": return Number(`0x${copyValue}`)
  // }
  return Number(`0x${copyValue}`)
}

export {getColorByStatusUnits, hex2number};